import { Component, AfterViewInit, ElementRef } from '@angular/core';
import { IntersectionObserverService } from 'src/app/intersection-observer.service';

@Component({
  selector: 'app-business-numbers',
  templateUrl: './business-numbers.component.html',
  styleUrls: ['./business-numbers.component.css'],
})
export class BusinessNumbersComponent implements AfterViewInit {
  experience = 0;
  projects = 0;
  clients = 0;

  private experienceTarget = 15;
  private projectsTarget = 482;
  private clientsTarget = 400;

  private animationDuration = 2000; // 2 seconds

  constructor(
    private intersectionObserverService: IntersectionObserverService,
    private elementRef: ElementRef
  ) {}

  ngAfterViewInit(): void {
    const targetElement = this.elementRef.nativeElement.querySelector('.social_slide');

    if (targetElement) {
      this.intersectionObserverService.observe(targetElement);

      // Set up a MutationObserver to detect when the 'in-viewport' class is added
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (targetElement.classList.contains('in-viewport')) {
              this.startAnimations();
            }
            else {
              this.experience=0;
              this.projects=0;
              this.clients=0;

            }
          }
        }
      });

      // Start observing the target element for attribute changes
      observer.observe(targetElement, { attributes: true });
    }
  }

  private startAnimations(): void {
    this.animateValue('experience', this.experienceTarget, this.animationDuration);
    this.animateValue('projects', this.projectsTarget, this.animationDuration);
    this.animateValue('clients', this.clientsTarget, this.animationDuration);
  }

  private animateValue(property: 'experience' | 'projects' | 'clients', target: number, duration: number): void {
    const start = this[property];
    const startTime = performance.now(); // Get the current time
    const endTime = startTime + duration; // Calculate end time

    const step = (currentTime: number) => {
      // Calculate the progress of the animation
      const progress = Math.min((currentTime - startTime) / duration, 1);

      // Compute the current value
      this[property] = Math.round(start + progress * (target - start));

      // Continue animation if not finished
      if (currentTime < endTime) {
        requestAnimationFrame(step);
      } else {
        // Ensure the target value is set at the end
        this[property] = target;
      }
    };

    // Start the animation
    requestAnimationFrame(step);
  }
}
